(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');
  const navItems = document.querySelectorAll('.header__nav-item');
  let isMenuOpen = false;
  const searchToggle = document.getElementById('search-toggle');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = searchOverlay ? searchOverlay.querySelector('.search-overlay__close') : null;
  const searchBackdrop = searchOverlay ? searchOverlay.querySelector('[data-search-backdrop]') : null;
  const searchInput = searchOverlay ? searchOverlay.querySelector('.search-overlay__input') : null;
  const searchClear = searchOverlay ? searchOverlay.querySelector('.search-overlay__clear') : null;
  const searchResultsWrap = document.getElementById('search-results-wrap');
  const searchResultsContainer = document.getElementById('search-results');

  // Transparent header scroll handling for video hero
  const videoHero = document.querySelector('[data-video-hero]');
  const headerWrapper = document.querySelector('.header-wrapper');
  const announcementBar = document.querySelector('.announcement-bar-section');
  
  if (videoHero && headerWrapper) {
    // Add class to body to enable transparent header styles
    document.body.classList.add('has-video-hero');
    
    // Calculate and set announcement bar height as CSS variable
    const updateAnnouncementBarHeight = () => {
      if (announcementBar) {
        const height = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    };
    
    // Get the height of the video hero for scroll threshold
    const getVideoHeroHeight = () => videoHero.offsetHeight;
    
    // Handle scroll to toggle header background
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const videoHeroHeight = getVideoHeroHeight();
      
      // Add scrolled class when past the video hero (minus some offset for smoother transition)
      if (scrollTop > videoHeroHeight - 100) {
        headerWrapper.classList.add('header-wrapper--scrolled');
      } else {
        headerWrapper.classList.remove('header-wrapper--scrolled');
      }
    };
    
    // Initial setup
    updateAnnouncementBarHeight();
    handleScroll();
    
    // Add scroll listener with throttling for performance
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Handle resize to recalculate heights
    window.addEventListener('resize', function() {
      updateAnnouncementBarHeight();
      handleScroll();
    });
  }

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('search-is-open');
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('search-is-open');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  if (searchInput && searchClear) {
    searchInput.addEventListener('input', function() {
      searchClear.classList.toggle('is-visible', searchInput.value.length > 0);
    });

    searchClear.addEventListener('click', function() {
      searchInput.value = '';
      searchClear.classList.remove('is-visible');
      if (searchResultsWrap) searchResultsWrap.style.display = 'none';
      searchInput.focus();
    });
  }

  var searchTimer = null;
  var searchAbort = null;

  function centsToMoney(cents) {
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function doSearch(term) {
    if (!term || term.length < 2 || !searchResultsContainer) return;

    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();

    if (searchResultsWrap) searchResultsWrap.style.display = 'block';
    searchResultsContainer.innerHTML = '<div class="search-overlay__loading"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="2" x2="12" y2="6"><animate attributeName="opacity" values="1;0.3" dur="1s" repeatCount="indefinite"/></line><line x1="12" y1="18" x2="12" y2="22"><animate attributeName="opacity" values="0.3;1" dur="1s" repeatCount="indefinite"/></line></svg></div>';

    var url = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8';

    fetch(url, { signal: searchAbort.signal })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchResultsContainer.innerHTML = '<div class="search-overlay__no-results">Geen resultaten gevonden voor \u201c' + term.replace(/</g, '&lt;') + '\u201d</div>';
          return;
        }

        var html = '<h3 class="search-overlay__results-heading">Producten</h3><div class="search-overlay__products">';
        products.forEach(function(p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = p.price ? centsToMoney(parseInt(parseFloat(p.price) * 100)) : '';
          if (p.price_min && p.price_min !== p.price_max) {
            price = 'Vanaf ' + centsToMoney(parseInt(parseFloat(p.price_min) * 100));
          }
          html += '<a href="' + p.url + '" class="search-overlay__product">';
          if (img) {
            html += '<div class="search-overlay__product-image"><img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="200" height="200"></div>';
          } else {
            html += '<div class="search-overlay__product-image"></div>';
          }
          html += '<span class="search-overlay__product-title">' + (p.title || '') + '</span>';
          if (price) html += '<span class="search-overlay__product-price">' + price + '</span>';
          html += '</a>';
        });
        html += '</div>';
        html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="search-overlay__view-all">Alle resultaten bekijken &rarr;</a>';
        searchResultsContainer.innerHTML = html;
      })
      .catch(function(e) {
        if (e.name !== 'AbortError') {
          searchResultsContainer.innerHTML = '';
          if (searchResultsWrap) searchResultsWrap.style.display = 'none';
        }
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      var val = searchInput.value.trim();
      if (val.length < 2) {
        if (searchResultsWrap) searchResultsWrap.style.display = 'none';
        if (searchResultsContainer) searchResultsContainer.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function() { doSearch(val); }, 300);
    });
  }

  // Toggle mobile menu
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      isMenuOpen = !isMenuOpen;
      nav.classList.toggle('header__nav--open');
      menuToggle.classList.toggle('is-open');
    });
  }

  // Handle dropdown toggles on mobile
  navItems.forEach(item => {
    const link = item.querySelector('.header__nav-link--has-dropdown');
    if (link) {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 989) {
          e.preventDefault();
          // Close other dropdowns
          navItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.classList.remove('header__nav-item--open');
            }
          });
          item.classList.toggle('header__nav-item--open');
        }
      });
    }
  });

  // Close menu when clicking outside
  document.addEventListener('click', function(event) {
    if (isMenuOpen && !nav.contains(event.target) && !menuToggle.contains(event.target)) {
      nav.classList.remove('header__nav--open');
      menuToggle.classList.remove('is-open');
      isMenuOpen = false;
      
      // Close all dropdowns
      navItems.forEach(item => {
        item.classList.remove('header__nav-item--open');
      });
    }
  });

  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > 989) {
        nav.classList.remove('header__nav--open');
        menuToggle.classList.remove('is-open');
        isMenuOpen = false;
        
        // Close all dropdowns
        navItems.forEach(item => {
          item.classList.remove('header__nav-item--open');
        });
      }
    }, 250);
  });
});

  } catch(e) { console.error(e); }
})();
})();
